import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    marker: {
      color: 'white',
      fontFamily: 'Source Sans Pro',
      fontWeight: 400,
      fontSize: '12px',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      lineHeight: '1.2',
      textOverflow: 'ellipsis',
      minWidth: '100px',
      overflow: 'hidden',
    },
  }),
)
